import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/fedex-luggage-shipping.jpg'),
    alt: 'fedex luggage shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'fedex luggage shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'FedEx <span>Luggage Shipping</span><span>Services Available</span>',
  description:
    'ShipAndStorage offers a seamless FedEx Luggage Shipping service, making travel stress-free and affordable. Avoid long baggage lines, excess airline fees, and the risk of lost luggage by shipping your bags securely to your destination.',
  image: {
    url: '/images/v2/pages/landing-pages/fedex-luggage-shipping/hero-image.jpg',
    alt: 'FedEx Luggage Shipping Services Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for FedEx Luggage Shipping' }
}

export const ourProcessSectionContent = {
  title: 'Secure FedEx Luggage Shipping Services',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Arrange Pickup Today' },

  image: {
    url: '/images/v2/pages/landing-pages/fedex-luggage-shipping/secure-fedex-luggage-shipping-services.png',
    alt: 'Secure FedEx Luggage Shipping Services'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Book your FedEx Luggage Shipping in minutes through our simple online system. Enter your destination, select your preferred shipping speed, and receive a tracking number instantly.',
      image: {
        src: '/images/v2/pages/common/easy-online-booking2.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Safe Pickup and Handling',
      description:
        'FedEx professionals handle your luggage with care from pickup to delivery. With high-quality packaging and strict safety measures, your belongings remain protected throughout transit.',
      image: {
        src: '/images/v2/pages/common/safe-handling-and-pickup.png',
        alt: 'Safe Pickup and Handling'
      }
    },
    {
      id: 3,
      title: 'Timely and Reliable Delivery',
      description:
        'Enjoy on-time luggage delivery to more than 220 countries and territories. Real-time tracking lets you monitor your shipment every step of the way.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Timely and Reliable Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Reliable FedEx Luggage Shipping Solutions',
  description:
    "ShipAndStorage provides dependable FedEx Luggage Shipping solutions for travelers, students, and business professionals. Whether you're relocating or shipping extra baggage, our efficient process ensures safe and timely delivery.",
  image: {
    src: '/images/v2/pages/landing-pages/fedex-luggage-shipping/reliable-fedex-luggage-shipping-solutions.jpg',
    alt: 'Reliable FedEx Luggage Shipping Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of International Luggage Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'Ship your luggage ahead and enjoy a hands-free travel experience. No need to wait at baggage claims or struggle with heavy bags.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective',
      description:
        'Reduce expensive airline baggage fees. FedEx Luggage Shipping is often more affordable than checking multiple bags at the airport.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Cost-Effective'
      }
    },
    {
      id: 3,
      title: 'Advanced Tracking',
      description:
        'Stay informed with 24/7 tracking updates. Know exactly where your luggage is throughout the journey.',
      image: {
        src: '/images/v2/pages/common/real-time-tracking.png',
        alt: 'Advanced Tracking'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for FedEx Luggage Shipping?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Business Travelers',
          description:
            'Ensure your work essentials, trade show materials, and business gear arrive securely and on time.'
        },
        {
          id: 2,
          title: 'Students Moving Abroad',
          description:
            'Easily ship your luggage, books, and personal items without dealing with extra baggage fees at the airport.'
        },
        {
          id: 3,
          title: 'Frequent Travelers',
          description:
            'Avoid long baggage lines and potential airline mishandling by shipping your luggage ahead of time.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/fedex-luggage-shipping/who-should-choose-us-for-fedex-luggage-shipping.jpg',
        alt: 'Who Should Choose Us for FedEx Luggage Shipping?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Luggage Shipping',
      description:
        'Ship your suitcases securely with FedEx Luggage Shipping. Enjoy hassle-free travel and on-time delivery to any destination.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Club Shipping',
      description:
        'Avoid airline fees and damage risks by shipping your golf clubs directly to your golf course or resort.',
      image: {
        src: '/images/v2/pages/common/Golf-Club-Shipping.png',
        alt: 'Golf Club Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Moving Box Shipping',
      description:
        'Relocating? We offer reliable and cost-effective shipping for moving boxes, ensuring your items arrive safely.',
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Moving Box Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Ski and Snowboard Shipping',
      description:
        'Send your ski and snowboard gear ahead to your winter destination and avoid airport handling issues.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Ski and Snowboard Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for FedEx Luggage Shipping?',

  image: {
    url: '/images/v2/pages/landing-pages/fedex-luggage-shipping/why-choose-shipandstorage-for-fedex-luggage-shipping.jpg',
    alt: 'Why Choose ShipAndStorage for FedEx Luggage Shipping?'
  },

  articles: [
    {
      id: 1,
      title: 'Global Reach',
      description: 'Ship luggage to over 220 countries with FedEx’s trusted international network.'
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description: 'Save money compared to airline baggage fees with our budget-friendly shipping options.'
    },
    {
      id: 3,
      title: 'Secure Packaging and Handling',
      description: 'Every item is professionally packed and handled to ensure it arrives safely.'
    },
    {
      id: 4,
      title: 'Real-Time Tracking',
      description: 'Monitor your luggage every step of the way with advanced tracking technology.'
    },
    {
      id: 5,
      title: 'Fast and Reliable Delivery',
      description: 'Choose express or standard shipping with guaranteed on-time arrival.'
    },
    {
      id: 6,
      title: 'Dedicated Customer Support',
      description: 'Our expert team is available to assist with booking, tracking, and any shipping inquiries.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast and Secure FedEx Luggage Shipping Services',
  description:
    'FedEx luggage shipping services available now. Fast, secure, and reliable options for shipping your luggage with FedEx.',
  image: {
    src: '/images/v2/pages/landing-pages/fedex-luggage-shipping/fast-and-secure-fedex-luggage-shipping-services.png',
    alt: 'Fast and Secure FedEx Luggage Shipping Services'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Your FedEx Shipment' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we collaborate with top logistics providers to deliver high-quality storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a globally recognized logistics leader, dedicated to the safe storage and transportation of your belongings.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure and reliable global logistics services, ensuring safe storage and transport for your items, especially during the summer months.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers secure storage solutions and comprehensive global shipping options, ensuring that your items are handled with care throughout the entire process.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
